import { AdapterBase, RunResponse, RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { StoryNodeType } from "../../storyV2/domain/StoryNodeType";
import { FunctionName } from "../../storyV2/function/FunctionRegistry";
import { tryPromise } from "../../cutil/LangUtil";
import { AdapterErrorUtil } from "../../storyV2/adapter/AdapterErrorUtil";
export class StockAdapter extends AdapterBase {
    async run(story, edge, sourceNode, actionData) {
        if (sourceNode === undefined) {
            return Promise.reject();
        }
        let runNodes = [sourceNode];
        if (sourceNode.options.type === StoryNodeType.CUSTOMGROUP) {
            runNodes = sourceNode.children ?? [];
        }
        await this.globalContextUpdateQuery(story, sourceNode, edge);
        const res = await tryPromise(this.runAll(runNodes, { projectId: story.projectId, edgeId: edge.options.id }));
        if (res.error) {
            return new RunResponse(RunResponseType.ERROR, AdapterErrorUtil.getErrorMsg(res));
        }
        if (!res.data) {
            return new RunResponse(RunResponseType.ERROR, "empty data");
        }
        return new RunResponse(RunResponseType.STOCK, res.data);
    }
    async runAll(nodes, identityInfo) {
        const requestArr = nodes.map(value => {
            return this.runSingle(value.content, identityInfo);
        });
        const res = await Promise.all(requestArr);
        return res.flat();
    }
    async runSingle(input, identityInfo) {
        let newIdentityInfo = identityInfo;
        if (newIdentityInfo) {
            newIdentityInfo = {
                ...newIdentityInfo,
                fromCustomFunction: true,
            };
        }
        const func = this.funcRegistry.getByRegistName(FunctionName.stockPrices);
        const res = await func.run(input, newIdentityInfo);
        return res.data;
    }
}
